export default __webpack_public_path__ + "img/0cee5677148430cf786d1e3530c1470e.svg";